module.exports = __webpack_public_path__ + "img/payment-ideal.1de76f33.svg";